import axios from "axios";

// Local CRA has no API proxy. Use the local FastAPI server by default while
// developing; deployed same-origin builds and explicitly configured URLs keep
// their existing behaviour.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || (
  process.env.NODE_ENV === "development" ? "http://localhost:8000" : ""
);
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const getMarketOverview = () => client.get("/market/overview").then((r) => r.data);
export const getMarketChart = (timeframe) => client.get("/market/chart", { params: { timeframe } }).then((r) => r.data);
export const getDiscover = () => client.get("/discover").then((r) => r.data);
export const getCompanies = (params) => client.get("/companies", { params }).then((r) => r.data);
export const searchCompanies = (q) => client.get("/companies/search", { params: { q } }).then((r) => r.data);
export const getCompany = (ticker) => client.get(`/companies/${ticker}`).then((r) => r.data);
export const getCompanyPrices = (ticker, range) => client.get(`/companies/${ticker}/prices`, { params: { range } }).then((r) => r.data);
export const getCompanyEvents = (ticker, params = {}, signal) => client.get(`/events/${ticker}`, { params, signal }).then((r) => r.data);
export const getEventWhyItMatters = (ticker, eventId, signal) => client.get(`/ai/event/${ticker}/${eventId}/why-it-matters`, { signal }).then((r) => r.data);
export const compareCompanies = (a, b) => client.get("/compare", { params: { a, b } }).then((r) => r.data);
export const askAnalyst = (ticker, question_id) => client.post("/analyst/ask", { ticker, question_id }).then((r) => r.data);
export const getLearn = () => client.get("/learn").then((r) => r.data);
export const getLesson = (slug) => client.get(`/learn/${slug}`).then((r) => r.data);
export const getPortfolio = () => client.get("/portfolio").then((r) => r.data);
export const addHolding = (payload) => client.post("/portfolio/holdings", payload).then((r) => r.data);
export const deleteHolding = (id) => client.delete(`/portfolio/holdings/${id}`).then((r) => r.data);
